<template>
    <section class="marquee deposit-tab">
        <div class="container">
            <div class="deposit-outer">
                <div class="fast-bank-deposit b-contant">
                    <div class="back-btn p-al">
                        <a @click="$router.go(-1)" class="back-btn-lef">
                            <img src="@/assets/images/left-arrow-bg.png" alt="" />
                            {{ $t('back', 'Back') }}
                        </a>
                        <span class="bank-deps">{{ $t('withdrawal', 'Withdrawal') }}</span>
                    </div>
                </div>
                <div class="deposit-outer-body promotion">
                    <div class="inner-body pass-form mess-inner pro-cal mt-0">
                        <div class="withdraw-card">
                            <div class="withdraw-card-list v-1 v-one">
                                <h3>{{ $t('available-withdrawal', 'Available Withdrawal') }}</h3>
                                <p>{{ availableBalance}}</p>
                            </div>
                            <div class="withdraw-card-list v-1 v-two">
                                <!-- <div class="alert-tool">
                                    <img src="@/assets/images/alert.svg" alt="" />
                                    <div class="alert-tool-drop">{{ $t('the-withdraw-bonus-feature-enables-users', 'The withdraw bonus feature enables users to redeem and transfer earned bonuses to their accounts') }}.</div>
                                </div> -->
                                <h3>{{ $t('withdrawal-blocked-due-to-bonus', 'withdrawal blocked due to bonus') }}</h3>
                                <p>{{ lockedEarnData?.earnBonus?.toFixed(2) }}</p>
                            </div>
                            <div class="withdraw-card-list v-1 v-three">
                                <!-- <div class="alert-tool">
                                    <img src="@/assets/images/alert.svg" alt="" />
                                    <div class="alert-tool-drop">{{ $t('withdrawal-is-blocked-due-to-pending-turnover-requirements', 'Withdrawal is blocked due to pending turnover requirements. Complete the specified turnover to unlock withdrawal eligibility') }}.</div>
                                </div> -->
                                <h3>{{ $t('withdrawal-is-blocked-due-to-pending-turnover', 'Withdrawal Blocked Due to Pending Exposure') }}</h3>
                                <p>{{ userData?.exposure ?? 0 }}</p>
                            </div>
                        </div>
                        <div class="insta-withdraw">
                            <div class="bank-option">
                                <ul class="menu-secs">
                                    <li>
                                        <a type="button" @click="showAddAccountModal()" class="bank-item">
                                            <div class="bank-item-img"> <img src="@/assets/images/add-bank.svg" alt="" /> </div>
                                            <p>{{ $t('add-account', 'Add account') }}</p>
                                        </a>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'bank-details' }"  class="bank-item">
                                            <div class="bank-item-img"> <img src="@/assets/images/view-bank.svg" alt="" /> </div>
                                            <p>{{ $t('view-bank', 'View Bank') }}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="insta-bank-det">
                                <div class="select-speed" type="button" @click="toggleClass">
                                    <div class="insta_whi_draw op_close">
                                        <img src="@/assets/images/withdraw.png" alt="" class="slide-rup" />
                                        <h6 class="iPYHaL">{{ $t('insta-withdrawal', 'Withdrawal') }}</h6>
                                    </div>
                                    <img src="@/assets/images/arrowicon.gif" alt="" class="slide-gif" />
                                    <!-- <div class="insta_whi_draw" role="button" data-bs-toggle="modal" data-bs-target="#Normal_Withdrawal">
                                        <img src="@/assets/images/rupes.svg" alt="" class="slide-rup" />
                                        <h6 class="iPYHaL">{{ $t('normal-withdrawal', 'Normal Withdrawal') }}</h6>
                                        <p>({{ $t('1-to-2-days', '1 To 2 Days') }})</p>
                                    </div> -->
                                </div>
                            </div>
                            <div class="instantWithdarw-modal" :class="elementClass">
                                <div class="instantWithdarw-header">
                                    <img src="@/assets/images/withdraw.png" alt="">
                                    <h6>{{ $t('insta-withdrawal', 'Withdrawal') }}</h6>
                                    <div class="instantWithdarw-close" @click="toggleVisibility">
                                        <img src="@/assets/images/c_with.svg" alt="">
                                    </div>
                                </div>
                                <div class="instantWithdarw-body">
                                    <div class="withdraw-bal">Available Balance: <span>{{ availableBalance }}</span></div>
                                    <form>
                                        <div class="deposit-amount insta_with">

                                            <div class="input-area-wrap input-area-box">
                                                <fieldset class="textfield">
                                                    <input type="text" id="amount" maxlength="10" @input="amount = $helper.sanitizeNumber(+amount, +walletConfig?.withdrawal_range?.max || 99999999)" class="textfield__input" :placeholder="$t('enter-amount','Enter amount')" v-model="amount">
                                                </fieldset>
                                                <p v-if="errors.amount" class="req-pass" >{{ errors.amount  }}</p>
                                                <label class="font-right" for="">{{ $t('min', 'Min') }}: {{ walletConfig?.withdrawal_range?.min }} | {{ $t('max', 'Max') }}: {{ walletConfig?.withdrawal_range?.max }}</label>
                                            </div>
                                            <div class="input-area-wrap input-area-box">
                                                <fieldset class="textfield">
                                                    <select class="form-select" v-model="selectedBank" @change="validateFields" aria-label="Default select example">
                                                        <option value="" disabled selected>{{ $t('select-account', 'Select Account') }}</option>
                                                        <template v-for="item in accountsList" :key="item.client_account_id">
                                                            <option :value="item?.client_account_id">
                                                                {{ item?.method_name }}({{ item.account_holder_name }})
                                                            </option>
                                                        </template>
                                                    </select>
                                                </fieldset>
                                                <!-- <p v-if="errors.bank" class="req-pass" >{{ errors.bank  }}</p> -->
                                            </div>

                                            <div class="btn-form w_submit mt-2">
                                                <button type="button" :disabled="!canReset" @click="resetForm" class="Reset-btn">{{ $t('reset', 'Reset') }}</button>
                                                <button type="button" @click="withdrawAmountServiceCall" :disabled="amount < (walletConfig?.withdrawal_range?.min || 100)" class="btn-sum add-btn">{{ $t('submit', 'Submit') }}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="forgotWithdraw-wrap">
                            <a href="javascript:void(0)" class="wrdl-forgot-btn" @click="openWithdrawPassModal()">
                                {{$t('forgot-withdraw-password','Forgot Withdraw Password')}}?
                            </a>
                        </div>
                        <WalletInstructions instructionType="withdrawal" />
                        <TutorialVideo v-if="walletConfig?.withdrawal_video?.English || walletConfig?.withdrawal_video?.हिन्दी" type = "1"/>
                       
                        <div class="wallet-video-lang" v-if="tutorialVideosData && tutorialVideosData.length">
                            <div class="wallet-video-col" v-for="(tut,index) in tutorialVideosData" :key="index">
                                <h3>{{ $t('how-to-withdraw', 'How To Withdraw') }} ({{ tut.lang == 1 ? 'English' : 'Hindi' }})</h3>
                                <div class="embed-responsive">
                                    <iframe width="100%" height="315" :src="tut.link" frameborder="0" allowfullscreen="allowfullscreen"> </iframe>
                                </div>
                            </div>
                          </div>  
                    </div>
                </div>
            </div>
        </div>
    </section>
    

    <div class="modal fade" id="Normal_Withdrawal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close_w" data-bs-dismiss="modal" aria-label="Close">
                        <img src="@/assets/images/normal_w.svg" alt="">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="sc-NOpvV FbtZK">
                        <div class="sc-jSsgRB bonEyl">{{ $t('this-withdrawal-channel-is-currently-unavailable', 'This Withdrawal channel is currently unavailable, please try with other channel') }}.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <addAccountModal :paymentMethodList="paymentMethodList"></addAccountModal>
    <WithdrawalPasswordSetReset ref="withdrawSetReset" @isWithdrawalPasswordSet="isWithdrawalPasswordSet" :is_withdrawal_password_set="is_withdrawal_password_set"  @withdrawalPasswordHasBeenSet="is_withdrawal_password_set = true" />
</template>

<script>
import { defineAsyncComponent } from 'vue';
import {withdrawAmountClickValidation} from '../services/walletWithdraw';
import {getUserAccounts, withdrawWalletAmount, removeAccount} from '../services/withdrawDetails';
import { addAccount, openWithdrawPasswordModal} from "../services/withdrawAccountDetails"
import addAccountModal from '../components/addAccountModal.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
import WalletInstructions from '../components/WalletInstructions.vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
export default {
    name: "WalletWithdraw",
    inject: ['walletConfig'],
    data() {
		return {
			loading: false,
            isActive: false,
            isElementVisible: true,
            selectBankId: null,
            accountsList: [],
            amount: "",
            selectedBank: "",
            errors: {
                amount: null,
                bank: null,
            },
            userData: null,
            lockedEarnData: null,
            onlyBankStatus: false,
            selectedCardIndex: null,
            withdrawAccountType: '',
            paymentMethodList: null,
            is_withdrawal_password_set:false,
		}
	},
    components: {
        addAccountModal,
        TutorialVideo,
        WalletInstructions,
        WithdrawalPasswordSetReset,
    },
    mounted() {
        this.userAccountDetails();
        if(this.$auth.status){
            this.userData = this.$store?.getters?.stateUser;
            this.lockedEarnData = this.$store?.getters?.lockedEarnedData;
        }
        if(this.$route.params.newAccount){
            this.showAddAccountModal()  
            this.$router.push({ name: 'wallet-withdraw' });
        }
    },
    computed: {
        tutorialVideosData() {
            return this.walletConfig.videos ?.filter(item => item?.type == 3);
        },
        availableBalance() {
            return ((+this.$auth.user?.balance || 0) - (+this.$auth?.user?.earnBonus || 0) + parseInt(this.$auth.user?.expl || 0)).toFixed(2);
        },
        elementClass() {
            return this.isActive ? "open" : "close";
        },
        canSubmit() {
            return !this.errors.amount && !this.errors.bank && this.amount && this.selectedBank; // Enable when both fields are filled
        },
        canReset() {
            return this.amount || this.selectedBank; // Enable when any field has input
        },
        availableBalance() {
            let { balance = 0, exposure = 0 } = this.$auth?.user || {};
            let earnBonus = this.$auth?.user?.earnBonus || 0;
            return (parseFloat(balance) + parseFloat(exposure || 0) - parseFloat(earnBonus))?.toFixed(2);
        }
    },
    methods: {
        openWithdrawPassModal() {
            const closeButton = document.getElementById('closeBtn');
            if (closeButton) {
                closeButton.click();
            }
            this.openWithdrawPasswordModal();
        },
        isWithdrawalPasswordSet(){
            try {
                this.$apiCall('get', 'CHECK_WITHDRAWAL_PASSWORD', null, 'wallet', null).then(res => {
                    if(res.status == 200){
                        this.is_withdrawal_password_set =res.data.success;
                    }
                });
                
            } catch (error) {
                const message = sendError(error);
                console.log("============",message)
            }
        },

        async openWithdrawPasswordModal(){
            try{
                let response = await openWithdrawPasswordModal()
                if(!response?.error){
                    //  this.$helper.closeModal('acc-open-model');
                    this.$helper.openModal('#withdrawalPassword');
                    this.$refs.withdrawSetReset.otpHasBeenCalled()
                    this.$refs.withdrawSetReset.resetTimer();
                }else{
                    this.$errorToast(response?.error);
                }
            }
            catch(error){
                if(error) {
                    this.$errorToast(error);
                }
            }
        },
        showAddAccountModal() {
            this.$helper.openModal('#addAccountModal');
        },
        toggleClass() {
            this.isActive = !this.isActive; // Toggle the main class
        },
        toggleVisibility() {
            this.isActive = !this.isActive;
            this.resetForm()
        },
        async userAccountDetails() {
            let response = await getUserAccounts(this.walletConfig?.payment_method)
            this.accountsList = response.userAccounts;
            this.withdrawAccountType = response.withdrawAccountType;
            this.paymentMethodList = response.paymentMethods;
            if(this.accountsList && this.accountsList.length > 0) {
                this.selectUserAccount (this.accountsList?.[0]);
                this.selectedCardIndex = 0;
                this.selectBankId = this.accountsList[0].client_account_id;
            }
		},
        selectUserAccount(account){
            this.withdrawAccountType = {
                type : account.bank_name ? account.bank_name : account.payment_type_name,
                holderName: account.account_holder_name
            };
        },
        validateFields() {
            if (!this.selectedBank) {
                this.errors.bank = "Please Select An Account.";
            } else {
                this.errors.bank = null;
            }
        },
        async withdrawAmountServiceCall() {
			if(this.amount < (this.walletConfig?.withdrawal_range?.min || 100)){
                return false;
            }
            withdrawAmountClickValidation(this.amount, this.walletConfig, this.withdrawlBalance)
            if (this.amount > this.$auth?.user?.balance) {
                this.$errorToast('Insufficient balance.');
                return false;
            }
            this.$store.dispatch('setGlobalLoader', true);
            console.log('acc', this.accountId)
            let response = await withdrawWalletAmount(this.amount, this.selectBankId)
            if(!response?.error){
                this.$router.push({ name: 'Home' });
            }
		},
        resetForm() {
            this.amount = "";
            this.selectedBank = "";
            this.errors = { amount: null, bank: null };
        },
    }
}
</script>

<style scoped>
 .font-right {
    font-weight: 400;
    display: block;
    text-align: right;
    font-size: 13px;
    margin-top: -5px;
}
</style>